import { render, staticRenderFns } from "./PaymentItem.vue?vue&type=template&id=68fb6b69&scoped=true&"
import script from "./PaymentItem.vue?vue&type=script&lang=js&"
export * from "./PaymentItem.vue?vue&type=script&lang=js&"
import style0 from "./PaymentItem.vue?vue&type=style&index=0&id=68fb6b69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb6b69",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VChip,VList,VListItem,VListItemContent,VListItemTitle})
